import React from 'react';

import Icon from '../../../designSystem/Icon';

import styles from './HelpDeskCategory.module.scss';

export type HelpDeskCategoryQuestionT = {
  id?: string;
  title: string;
  onClick: () => void;
};

const HelpDeskCategoryQuestion = ({ title, onClick, id }: HelpDeskCategoryQuestionT) => {
  return (
    <div
      className={styles.help_desk_category_question_item}
      onClick={onClick}
      onKeyPress={onClick}
      role="button"
      tabIndex={0}
      id={id}
    >
      <p>{title}</p>
      <Icon
        name="chevron_right"
        size="medium"
        customClass={styles.help_desk_category_question_item_icon}
      />
    </div>
  );
};

export default HelpDeskCategoryQuestion;
